import { Suspense } from "react"
import { useTranslation } from "react-i18next"
import { Info } from "@phosphor-icons/react"
import { joinStrings } from "@/lib/joinString"
import { PreparationAdditionalInformation } from "@/modules/patients/detail/medication/de/preparation-additional-information"
import { Medication } from "@/modules/patients/detail/medication/de/search-results"
import { ArrElement } from "@/types/ArrElement"

interface PreparationSelectionProps {
  medication: Medication
  selectedPharma?: ArrElement<Medication["pharmaceuticalCentralNumberList"]>
}

const PreparationSelection = ({ medication, selectedPharma }: PreparationSelectionProps) => {
  const { t } = useTranslation()

  return (
    <div className="border-border mb-8 grid gap-4 rounded-lg border px-4 py-4" data-testid="preparation-medication">
      <div className="flex items-center">
        <div className="grid items-center">
          <span className="text-on-surface text-base leading-6 font-medium">
            {joinStrings([medication.name, ...medication.composition])}
          </span>
          {medication?.pharmaceuticalForm && (
            <span key={medication.pharmaceuticalForm?.ifaCode} className="text-on-surface-subdued text-xs leading-4">
              {medication.pharmaceuticalForm?.name}
            </span>
          )}
        </div>
      </div>
      {selectedPharma && (
        <Suspense fallback={null}>
          <PreparationAdditionalInformation pharmaceuticalCentralNumber={selectedPharma.pharmaceuticalCentralNumber} />
        </Suspense>
      )}
      {medication.isPrescriptionRequired && (
        <div className="bg-surface-subdued flex h-10 items-center rounded-md px-4 py-2">
          <Info className="text-on-surface-subdued" />
          <span className="text-on-surface ml-1 text-sm">{t("patient.medication.aPrescriptionIsRequired")}</span>
        </div>
      )}
    </div>
  )
}

export { PreparationSelection }
